import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Servicio que gestiona el estado de carga global de la aplicación
 */
@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private requestCount = 0;

  // -------------------- Endpoints de Estado de Carga --------------------
  /**
   * Establece el estado de carga de la aplicación.
   * Incrementa o decrementa un contador de solicitudes pendientes.
   * @param loading Estado de carga a establecer
   */
  setLoading(loading: boolean) {
    if (loading) {
      this.requestCount++;
      this.loadingSubject.next(true);
    } else {
      this.requestCount--;
      if (this.requestCount <= 0) {
        this.requestCount = 0;
        this.loadingSubject.next(false);
      }
    }
  }
} 